<template>
     <div id="data-list-list-view" class="data-list-container m-5">
        <vs-alert :color="response.AlertColor" :title="response.Title" :active.sync="response.StatusCode!=200&&response.StatusCode!=null">
            <span>{{response.Body}} </span> <router-link :to="{name:'InstructorAssessment'}" class="text-inherit underline">{{$t('Back')}}</router-link> 
            <Label @click="reload" style="color: rgba(var(--vs-primary), 1);cursor: pointer" class="ml-5 text-inherit underline">{{$t('ReAssessment')}}</Label>
        </vs-alert>

      <div v-if="response.StatusCode==200">
       
        <div class="vx-col lg:w-3/4" style="margin:auto">
            <vx-card > 
                <h4 v-html="response.Data.Title"></h4>
                <div  class="vx-row">
                    <div class="vx-col flex-1 mt-5">
  <p>{{$t('Course')}}</p>
          <v-select
            label="Name"
            class="mt-5 w-full"
            v-model="response.Data.CourseID"
            :options="courses"
              autocomplete 
            :reduce="Course => Course.ID"
          />
                    </div>
                    
                    <!-- <vs-select autocomplete class="vx-col flex-1 mt-5" label="Course" v-model="response.Data.CourseID"  >
                       <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in courses" />
                    </vs-select> -->
                         <div class="vx-col flex-1 mt-5">
  <p>{{$t('Instructor')}}</p>
          <v-select
            label="Name"
            class="mt-5 w-full"
            v-model="response.Data.InstructorID"
            :options="instructors"
              autocomplete 
            :reduce="Instructor => Instructor.ID"
          />
                    </div>
                 
                </div>
            </vx-card>

              <vx-card title="Keys" class="mt-5"> 
              <div class="vx-row">
                  <label class="ml-10">[1] {{$t('Unacceptable')}}</label>
                  <label class="ml-10">[2] {{$t('Poor')}}</label>
                  <label class="ml-10"> [3] {{$t('Acceptable')}}</label>
                  <label class="ml-10">[4] {{$t('VeryGood')}}</label>
                  <label class="ml-10">[5] {{$t('Excellent')}}</label>
                  
              </div>
          </vx-card>
              
            <vx-card class="p-5 mt-5" v-for="(item,index) in response.Data.CustomerReviewQuestions" :key="index" >
                <div class="vx-row">
                    <label class="mt-3 pl-3 vx-col lg:w-3/4">{{item.QuestionText}}</label>
                      <vs-checkbox class="mt-2" v-if="item.QuestionTypeID==2" v-model="item.Answer"></vs-checkbox> 
                       <div v-if="item.QuestionTypeID==5" class="vx-row">
                            <div v-for="(Ans,count) in item.CustomerReviewAnswers" :key="Ans.ID"  class="mt-2">
                                <vs-radio v-model="item.Answer"  :vs-name="item.QuestionText"  :vs-value="Ans.ID"><span  :style="{'filter': item.Answer!=Ans.ID?'opacity(50%)':'opacity(100%)','font-size': item.Answer!=Ans.ID?'15px':'25px'}" >[{{count+1}}]</span></vs-radio>
                            </div> 
                        </div>
                </div>
                <div class="mt-5 ml-5" v-if="item.QuestionTypeID==3">
                    <div v-for="Ans in item.CustomerReviewAnswers" :key="Ans.ID">
                        <vs-radio v-model="item.Answer"  :vs-name="item.QuestionText"  :vs-value="Ans.ID">{{Ans.AnswerText}}</vs-radio>
                    </div>
                </div>
                <div class="pl-5" v-if="item.QuestionTypeID==1">
                    <vs-textarea  class="w-full" v-model="item.Answer"></vs-textarea> 
                </div>
            </vx-card>
         </div> 
        <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button type="border"   to="/InstructorAssessment" class="px-4 w-full md:w-auto mr-6">{{$t('Back')}}</vs-button>
                <vs-button @click="submitReview" :disabled="!isFormValid">{{$t('SaveChange')}} </vs-button>
            </div>
        </div>
      </div>
    </div>
</template>
<script>

import moduleCourseReview from "@/store/customerReview/courseReview/moduleCourseReview.js";
import moduleAssessmentResult from "@/store/customerReview/assessmentResult/moduleAssessmentResult.js";
import { domain } from '@/gloabelConstant.js'
import moduleCourse from "@/store/course/moduleCourse.js";
import moduleInstructor from "@/store/instructor/moduleInstructor.js";
import vSelect from 'vue-select';
export default {
     data(){
        return{
            response:{},
            DownUrl:domain,
            
        }
    },
    components:{
        vSelect
    },
    methods:{
        reload()
        {
             this.$router.go()
        },
        submitReview(){
            this.$store.dispatch('AssessmentResultList/SubmitInstructorAssessmentResult',
            this.response.Data).then(()=>{
                debugger
                this.response.StatusCode=201;
                this.response.Body="Assessment submited successfully";
                this.response.AlertColor="success";
                this.response.Title="Successfully";

            }).catch(() => {
                 debugger
                this.response.StatusCode=404;
                this.response.Body="Unexpected error";
                this.response.AlertColor="danger";
               
                 this.response.Title="Error";
            })
            
           this.$store.state.InstructorReviewList.search.pageNum=1;
        }
    },
    computed:{
        isFormValid() {
         debugger
        return   this.response.Data.CourseID != undefined && this.response.Data.InstructorID !=undefined&& this.response.Data.InstructorID !=0;
    },
      courses() {
           return this.$store.state.courseList.courses;
       },
        instructors() {
        debugger;
        return this.$store.state.instructorList.instructors;
        }
    },
    created(){
           if (!moduleCourseReview.isRegistered) {
               this.$store.registerModule("CourseReviewList", moduleCourseReview);
              moduleCourseReview.isRegistered = true;
            }

           if (!moduleAssessmentResult.isRegistered) {
               this.$store.registerModule("AssessmentResultList", moduleAssessmentResult);
               moduleAssessmentResult.isRegistered = true;
            }

            if (!moduleCourse.isRegistered) {
                this.$store.registerModule("courseList", moduleCourse);
                moduleCourse.isRegistered = true;
                }
                this.$store.dispatch("courseList/fetchDataListItems");

                if (!moduleInstructor.isRegistered) {
                this.$store.registerModule("instructorList", moduleInstructor);
                moduleInstructor.isRegistered = true;
                }
                this.$store.dispatch("instructorList/fetchDataListItems");

            const Code = this.$route.params.Code
            debugger
            if(Code!=undefined)
            {
                var data={};
                data.Code=Code;
                data.AssessmentTypeID=1;
                this.$store.dispatch("CourseReviewList/getCourseReviewByCode", data)
                .then(res => { 
                    debugger
                    this.response = res.data;
                })
                .catch(() => {
                   this.response.StatusCode=404;
                   this.response.Body="Unexpected error";
                   this.response.AlertColor="danger";
                   this.response.Title="Error";
                })
            }
        }
}
</script>
<style>
.vs-radio--circle{
    display: none;
}
.vs-radio--borde
{
     display: none;
}
</style>